import type { Map as MapLibreMap } from 'maplibre-gl';
import { createContext, useContext } from 'react';
import type { InteractiveLayers } from './interactiveLayers';
import type { OverlayRegistry } from './overlays';

export interface MapContextValue {
  /** The map once its style has loaded; null before that. */
  map: MapLibreMap | null;
  overlays: OverlayRegistry;
  interactiveLayers: InteractiveLayers;
}

export const MapContext = createContext<MapContextValue | null>(null);

function useMapContext() {
  const ctx = useContext(MapContext);
  if (!ctx) throw new Error('Map hooks must be used inside <MapProvider>');
  return ctx;
}

export const useMap = () => useMapContext().map;
export const useOverlays = () => useMapContext().overlays;
export const useInteractiveLayers = () => useMapContext().interactiveLayers;
